import { DOOR_FETCHED, SET_DOOR } from "../types";

const initialState = {
  doorData: [] as any,
  singleDoor: {},
};
const doorsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DOOR_FETCHED:
      return {
        ...state,
        doorData: action.doorData,
        loading: false,
      };

    case SET_DOOR:
      return {
        ...state,
        singleDoor: action.singleDoor,
      };

    default:
      return state;
  }
};

export default doorsReducer;



